import React, { useRef } from 'react';
import { useStyles, Flex, Image } from '@archipro-design/aria';
import * as S from './MobilePaintPalette.style';
import { CloseLine } from '@archipro-design/icons';
import type { PaintProduct } from '@modules/paint-picker/type';
import { Colour } from '@modules/paint-picker/component/paint-colours/Colour';
import {
    getReseneLogoAdEventData,
    useAdEventHandler,
    useTracker,
} from '@archipro-website/tracker';
import { usePaintPickerContext } from '../../context/PaintPickerContext';
import { useConfigContext } from '../../../../../../config/src/bindings/react/ConfigContext';
import { Link } from '@remix-run/react';
import { RESENE_LOGO_MOBILE } from '../../config';

export const MobilePaintPalette = ({
    title,
    link,
    code,
    rgb,
}: PaintProduct) => {
    const { css } = useStyles();
    const tracker = useTracker();
    const config = useConfigContext();
    const { closePaintPicker } = usePaintPickerContext();
    const reseneAd = getReseneLogoAdEventData();
    const reseneAdRef = useRef(null);
    const { onClick: onReseneLogoClick } = useAdEventHandler(
        reseneAd,
        reseneAdRef,
        {
            disableServeEvent: true,
        }
    );

    return (
        <Flex column className={css(S.Wrapper)}>
            <Flex
                ref={reseneAdRef}
                as={Link}
                to={'/professional/resene'}
                onClick={() => onReseneLogoClick('Ad_CTAClick')}
            >
                <Image
                    src={`${config.assetsBaseUrl}${RESENE_LOGO_MOBILE}`}
                    width={121}
                    height={55}
                    layout="responsive"
                    alt="Sponsored by Resene"
                    variables={{
                        placeholderBackgroundColorLight: 'transparent',
                    }}
                />
            </Flex>
            <Flex className={css(S.Container)}>
                {link ? (
                    <a
                        target="_blank"
                        href={link}
                        rel="noopener"
                        className={css(S.InnerContainer)}
                        onClick={() => {
                            tracker.log(
                                'Resene-PaintPicker-Hover-Order-Testpot',
                                {
                                    url: new URL(window.location.href),
                                }
                            );
                        }}
                    >
                        <Flex vAlign="center" gap="space-10">
                            <div className={css(S.ColourDetails)}>
                                <p className={css(S.ColourName)}>{title}</p>
                                <p className={css(S.ColourCode)}>{code}</p>
                                <p className={css(S.ProductLink)}>Get sample</p>
                            </div>
                            <Colour show={true} rgb={rgb} />
                        </Flex>
                    </a>
                ) : (
                    <Flex
                        vAlign="center"
                        gap="space-10"
                        className={css(S.InnerContainer)}
                    >
                        <div className={css(S.ColourDetails)}>
                            <p className={css(S.ColourName)}>{title}</p>
                            <p className={css(S.ColourCode)}>{code}</p>
                        </div>
                        <Colour show={true} rgb={rgb} />
                    </Flex>
                )}
                <CloseLine
                    className={css(S.CloseButton)}
                    onClick={closePaintPicker}
                />
            </Flex>
        </Flex>
    );
};
